import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translations, SUPPORTED_LANGUAGES } from '@zap/shared-logic';

export { SUPPORTED_LANGUAGES };
export type { SupportedLanguage } from '@zap/shared-logic';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translations.en },
      es: { translation: translations.es },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'zap_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
